module.exports = __webpack_public_path__ + "img/masthead3.f8fcb5a6.jpg";